import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { groupBy } from '@progress/kendo-data-query';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserActionSettingChanged } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.actions';
import { OpenDynamicLinkAutoOpenTriggersEnum } from 'src/app/samwebDescription/samweb/userActions/openDynamicLinkAutoOpenTriggersEnum';
import { OpenDynamicLinkActionSettingRemoteDto } from 'src/generated/signalR/open-dynamic-link-action-setting-remote-dto';
import { ActionSpecificSettingsComponent } from '../action-specific-settings-component';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';
import { OpenDynamicLinkAutoOpenTrigger } from 'src/generated/signalR/open-dynamic-link-auto-open-trigger';

@Component({
   selector: 'samweb-open-dynamic-link-settings',
   templateUrl: './open-dynamic-link-settings.component.html',
   styleUrls: ['./open-dynamic-link-settings.component.scss'],
})
export class OpenDynamicLinkSettingsComponent extends ActionSpecificSettingsComponent implements OnInit {
   public actionSetting$: Observable<OpenDynamicLinkActionSettingRemoteDto>;

   public possibleAutoOpenTriggers = groupBy(OpenDynamicLinkAutoOpenTriggersEnum.values() as OpenDynamicLinkAutoOpenTriggersEnum[], [
      { field: 'groupNameTranslationKey' },
   ]);

   constructor(private store: Store) {
      super();
   }

   ngOnInit() {
      this.actionSetting$ = this.store.select(ToolbarSettingsState.getActionSettingFn).pipe(
         map((fn) => fn(this.brickInstanceId, this.toolbarId, this.actionId)),
         map((x) => x as OpenDynamicLinkActionSettingRemoteDto),
         map((x) => _.cloneDeep(x))
      );
   }

   urlChanged(settings: OpenDynamicLinkActionSettingRemoteDto, newUrl: string) {
      settings.url = newUrl;
      this.store.dispatch(new UserActionSettingChanged(this.brickInstanceId, this.toolbarId, this.actionId, settings));
   }

   autoOpenTriggersChanged(settings: OpenDynamicLinkActionSettingRemoteDto, newValue: OpenDynamicLinkAutoOpenTrigger[]) {
      settings.autoOpenTriggers = newValue;
      this.store.dispatch(new UserActionSettingChanged(this.brickInstanceId, this.toolbarId, this.actionId, settings));
   }
}
